<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div fxLayout="column" class="ws-body">
  <!-- <app-user-header header="Change Password"></app-user-header> -->
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="ws-change-password-header"
    [ngClass]="{
      'ws-margin-bottom': isCustomer(),
      'ws-margin-bottom-4': !isCustomer(),
      'sc-margin-top-tab': isTabDevice()
    }"
  >
    <div class="ws-change-password" fxFlex="100" fxLayoutAlign="center center">
      Change Password
    </div>
  </div>

  <div
    fxLayout="column"
    fxLayoutAlign="space-between center"
    class="ws-form-btn"
    (keyup.enter)="passwordChange()"
  >
    <div *ngIf="isCustomer()" fxLayout="row" fxLayoutAlign="center center">
      <p class="nvc-text-align-center">OTP has been sent to {{ username }}</p>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-evenly center"
      fxLayoutGap="1em"
      [formGroup]="otpForm"
      *ngIf="isCustomer()"
    >
      <input
        #box1
        formControlName="box1"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(1)"
        (focus)="onFocusEvent(1)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box2
        formControlName="box2"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(2)"
        (focus)="onFocusEvent(2)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box3
        formControlName="box3"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(3)"
        (focus)="onFocusEvent(3)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box4
        formControlName="box4"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(4)"
        (focus)="onFocusEvent(4)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box5
        formControlName="box5"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(5)"
        (focus)="onFocusEvent(5)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
      <input
        #box6
        formControlName="box6"
        class="nvs-input-otp border-focus-blue"
        type="number"
        (input)="onKeyUpFunction(6)"
        (focus)="onFocusEvent(6)"
        (paste)="onPasteOtp($event)"
        min="0"
        max="9"
      />
    </div>
    <div
      *ngIf="isCustomer() && isRegistrationOTPActive"
      class="nvc-font-size-20 nvc-time-text ws-bold nvc-text-align-center"
    >
      Resend OTP in {{ timeLeft }}
    </div>
    <div
      *ngIf="isCustomer() && !isRegistrationOTPActive"
      fxLayout="row"
      fxLayoutAlign="center center"
      [ngClass]="{
        'nvc-otp-verify-button-val': !isRegistrationOTPActive,
        'nvc-otp-verify-button-val-unavailable': isRegistrationOTPActive
      }"
      [disabled]="isRegistrationOTPActive"
      (click)="isRegistrationOTPActive ? '' : sendOTP()"
    >
      <p>Resend OTP</p>
    </div>
    <form [formGroup]="changePasswordForm" fxLayout="column" fxLayoutGap="1rem">
      <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!isCustomer()">
        <mat-form-field appearance="outline" class="sc-mat-form-input">
          <mat-label class="sc-input-label">Current Password</mat-label>
          <input
            matInput
            formControlName="currentPassword"
            [type]="currentPasswordType"
            class="notranslate"
            i18n-placeholder
          /><br />
          <mat-icon
            matSuffix
            [svgIcon]="currentPasswordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
            class="nvc-eye ws-cursor-pointer"
            (click)="togglePasswordVisibility('currentPassword')"
          >
          </mat-icon>
        </mat-form-field>
      </div>
      <div
        *ngIf="
          currentPassword.invalid &&
          (currentPassword.touched || currentPassword.dirty)
        "
        fxLayout="row"
        fxLayoutAlign="start center"
        class="error"
      >
        <small class="notranslate" i18n *ngIf="currentPassword.errors?.required"
          >*Password is required
        </small>
        <small
          class="notranslate"
          i18n
          *ngIf="currentPassword.errors?.minlength"
          >*Password must be at least 8 characters
        </small>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field appearance="outline" class="sc-mat-form-input">
          <mat-label class="sc-input-label">New Password</mat-label>
          <input
            matInput
            formControlName="newPassword"
            [type]="newPasswordType"
            class="notranslate"
            i18n-placeholder
          /><br />
          <mat-icon
            matSuffix
            [svgIcon]="newPasswordVisibility ? 'eyeIcon' : 'eyeSlashIcon'"
            class="nvc-eye ws-cursor-pointer"
            (click)="togglePasswordVisibility('newPassword')"
          >
          </mat-icon>
        </mat-form-field>
      </div>
      <div
        *ngIf="
          newPassword.invalid && (newPassword.touched || newPassword.dirty)
        "
        fxLayout="row"
        fxLayoutAlign="start center"
        class="error"
      >
        <small class="notranslate" i18n *ngIf="newPassword.errors?.required"
          >*Password is required
        </small>
        <small class="notranslate" i18n *ngIf="newPassword.errors?.minlength"
          >*Password must be at least 8 characters
        </small>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field appearance="outline" class="sc-mat-form-input">
          <mat-label class="sc-input-label">Confirm new Password</mat-label>
          <input
            matInput
            formControlName="confirmPassword"
            [type]="confirmPasswordType"
            i18n-placeholder
            class="notranslate"
          /><br />
          <mat-icon
            matSuffix
            [svgIcon]="confirmPasswordVisiblity ? 'eyeIcon' : 'eyeSlashIcon'"
            class="nvc-eye ws-cursor-pointer"
            (click)="togglePasswordVisibility('confirmPassword')"
          >
          </mat-icon>
        </mat-form-field>
      </div>
      <div
        *ngIf="changePasswordForm.errors?.misMatch"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="error"
      >
        <small
          class="notranslate"
          i18n
          *ngIf="changePasswordForm.errors?.misMatch"
          >*Passwords do not match
        </small>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" class="error">
        <p *ngIf="isErrorVerifyngOTP">{{ errorMessage }}</p>
      </div>
      <!-- <button (click)="passwordChange()" [disabled]="changePasswordForm.invalid" i18n class="notranslate">Save Changes</button> -->
      <div class="bspacing"></div>
    </form>

    <div
      fxLayout="row"
      class="nvc-padding-bottom nvc-width-80"
      fxLayoutAlign="space-around"
    >
      <button
        fxFlex="45"
        class="nvc-button ws-update-btn ws-cursor-pointer button-shadow-focus nvc-border-radius notranslate"
        (click)="passwordChange()"
        [disabled]="
          isCustomer() ? !isCustomerFormValid() : changePasswordForm.invalid
        "
        i18n
      >
        UPDATE
      </button>
      <button
        fxFlex="45"
        *ngIf="!isMobileDevice() || dialogChangePassword"
        class="nvc-button ws-cursor-pointer button-shadow-focus nvc-cancel-button nvc-border-radius"
        (click)="closeDialog()"
      >
        CANCEL
      </button>
    </div>
  </div>
</div>
